<template>
  <div class="pega-preview">
    <h6 class="margin-0">
      ※★の項目は原稿掲載時には非表示の内容となります。設定・登録内容のご確認をお願いいたします。
    </h6>
    <div class="pega-notice">
      ※話を聞きたい応募ボタンは掲載企業さま向け管理画面で「話を聞きたい応募受付」をONにした場合に表示されます
    </div>
    <div class="pega-comment-block margin-top-05">
      <preview-job-comments
        :comments="codeCommentHighlights"
        :is-show="isShowComment"
        v-on="$listeners"
      />
      <table
        v-if="isFinishCreated"
        class="unstriped hover pega-table pega-preview-table pega-preview-table-word-break-all"
        :class="isShowComment ? 'pega-cursor-pen-only-id' : ''"
        data-test="code-setting"
      >
        <thead>
          <tr>
            <th colspan="2">
              コード設定
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!isClientJob">
            <th>★ 正式社名</th>
            <td
              :id="targetIdMap.code.officialCompanyName"
              class="boss-table-data"
              data-test="official-company-name"
            >
              {{ officialCompanyName }}
              <span class="boss-annotation-text">
                <div>※支店名、事業部、グループ名等の入力不可。</div>
                <div
                  v-if="!isNotOutputGoogleForJobs"
                  data-test="use-official-company-name"
                >
                  {{ usedAffiliatedSiteLabel }}
                </div>
              </span>
            </td>
          </tr>
          <tr v-if="!isClientJob">
            <th>★ 表示用社名</th>
            <td
              :id="targetIdMap.code.displayCompanyName"
              class="boss-table-data"
              data-test="display-company-name"
            >
              {{ displayCompanyName }}
              <div
                v-if="isNotOutputGoogleForJobs"
                class="boss-annotation-text"
                data-test="use-display-company-name"
              >
                {{ usedAffiliatedSiteLabel }}
              </div>
            </td>
          </tr>
          <tr v-if="!isClientJob">
            <th>★ 社名カナ</th>
            <td
              :id="targetIdMap.code.companyName"
              class="boss-table-data"
              data-test="company-name-kana"
            >
              {{ companyNameKana }}
            </td>
          </tr>
          <tr
            v-for="(business,i) in buisinessTexts"
            :key="'business-' + i"
            :data-test="'business-' + i"
          >
            <th :data-test="'business-header-' + i">
              ★ 業種コード[{{ i + 1 }}]
            </th>
            <td
              :id="targetIdMap.code.business + '-' + (i + 1)"
              class="boss-table-data"
              :data-test="'business-text-' + i"
            >
              {{ business }}
            </td>
          </tr>
          <tr v-if="!isClientJob && codeSetting.jobNameForAdmUser">
            <th>★ 管理用職種名</th>
            <td
              :id="targetIdMap.code.jobNameForAdmUser"
              class="boss-table-data"
              data-test="name-for-adm-user"
            >
              {{ codeSetting.jobNameForAdmUser }}
            </td>
          </tr>
          <tr v-if="!isClientJob">
            <th>★ 外部表示用職種名</th>
            <td
              :id="targetIdMap.code.jobNameForIndeed"
              class="boss-table-data"
              data-test="name-for-indeed"
            >
              {{ codeSetting.jobNameForIndeed }}
              <div
                v-if="codeSetting.showJobNameForIndeedNoticeText"
                class="notice"
                data-test="job-name-for-indeed-notice"
              >
                ※提携サイト掲載時にこちらの職種名が使用されます。
              </div>
            </td>
          </tr>
          <tr v-if="codeSetting.offerJobCodeTypeForm.hasOfferJobCodeSet">
            <th data-test="job-code-type-title">
              ★ 職種コード種別
            </th>
            <td
              :id="targetIdMap.code.jobType"
              class="boss-table-data"
              data-test="job-type"
            >
              {{ codeSetting.offerJobCodeTypeForm.name }}
              <div
                class="notice"
                data-test="offer-job-code-type-description"
              >
                {{ codeSetting.offerJobCodeTypeForm.description }}
              </div>
            </td>
          </tr>
          <tr v-if="isClientJob || codeSetting.primaryOfferJobName">
            <th data-test="job-primary-title">
              ★ 職種コード[1](プライマリ)
            </th>
            <td
              :id="targetIdMap.code.jobPrimary"
              class="boss-table-data"
              data-test="job-primary"
            >
              {{ codeSetting.primaryOfferJobName }}
            </td>
          </tr>
          <tr v-if="showOtherOfferJobNameList">
            <th data-test="job-other-title">
              ★ 職種コード[2]
            </th>
            <td
              :id="targetIdMap.code.jobOther"
              class="boss-table-data"
              data-test="job-other"
            >
              <template
                v-for="(otherOfferJobName, index) in codeSetting.otherOfferJobNameList"
              >
                <span
                  :key="index"
                  :data-test="'other-job-span-' + index"
                >
                  {{ dispOtherOfferJobName(otherOfferJobName) }}<br>
                </span>
              </template>
            </td>
          </tr>
          <tr>
            <th>雇用形態コード</th>
            <td
              :id="targetIdMap.code.employments"
              class="boss-table-data"
              data-test="employments"
            >
              {{ codeSetting.employments | joinArray }}
            </td>
          </tr>
          <tr>
            <th data-test="salary-code-example-title">
              <template v-if="!codeSetting.isSalaryDisplay">
                ★
              </template>年収例コード
              <div class="notice">
                ※50万円単位での選択になります
              </div>
            </th>
            <td
              :id="targetIdMap.code.salaryExample"
              class="boss-table-data"
              data-test="salary-code-example-body"
            >
              {{ codeSetting.salaryMap.min }}万円 ~ {{ codeSetting.salaryMap.max }}万円
              <div
                v-if="codeSetting.isSalaryDisplay"
                class="notice"
              >
                ※求人詳細内に表示されます。
              </div>
            </td>
          </tr>
          <tr>
            <th>勤務地コード</th>
            <td
              :id="targetIdMap.code.places"
              class="boss-table-data"
              data-test="workplaceNameList"
            >
              {{ codeSetting.workplaceNameList | joinArray }}
            </td>
          </tr>
          <tr>
            <th>働き方コード</th>
            <td
              :id="targetIdMap.code.workstyle"
              class="boss-table-data"
              data-test="workstyle"
            >
              {{ codeSetting.workstyle }}
            </td>
          </tr>
          <tr>
            <th>目安残業時間</th>
            <td
              :id="targetIdMap.code.overtimeWorkHours"
              class="boss-table-data"
              data-test="over-time-works"
            >
              {{ codeSetting.overtimeWorkHours }}
            </td>
          </tr>
          <tr v-if="!isClientJob || codeSetting.prCodes.length">
            <th>
              PRコード (<a
                target="_blank"
                style="cursor: pointer;"
                :href="userHelpMarkURL"
              >説明はこちら</a>)
            </th>
            <td
              :id="targetIdMap.code.prCode"
              class="boss-table-data"
              data-test="pr-code"
            >
              {{ codeSetting.prCodes | joinArray }}
              <div class="notice">
                ※PRコードを多めに設定したほうが、サイト内で求人広告の露出が増えます
              </div>
            </td>
          </tr>
          <tr v-if="showExpSkills">
            <th>
              ★ この求人で活かせるスキル・資格<br>/ 活かせるスキル
              <div class="notice">
                ※最大50個まで選択可
              </div>
            </th>
            <td
              :id="targetIdMap.code.jobSkill"
              class="boss-table-data pega-pre-wrap"
              data-test="skill"
              v-text="jobSkillString"
            />
          </tr>
          <tr v-if="showExpLicenses">
            <th>
              この求人で活かせるスキル・資格<br>/ 活かせる保有資格
              <div class="notice">
                ※最大10個まで選択可
              </div>
            </th>
            <td
              :id="targetIdMap.code.jobLicenses"
              class="boss-table-data pega-pre-wrap"
              data-test="license"
              v-text="jobLicenseString"
            />
          </tr>
          <tr v-if="codeSetting.applicationUrl">
            <th>専用応募フォームURL</th>
            <td
              :id="targetIdMap.code.applicationUrl"
              class="boss-table-data"
              data-test="application-url"
            >
              {{ codeSetting.applicationUrl }}
            </td>
          </tr>
          <tr
            v-for="(question,i) in codeSetting.originalQuestions"
            :key="'question-' + i"
            :data-test="'question-' + i"
          >
            <th :data-test="'question-header-' + i">
              応募フォーム用独自質問項目名（{{ question.id }}）
              <div class="notice">
                ※{{ question.name.length }}文字/{{ question.max }}文字
              </div>
            </th>
            <td
              :id="targetIdMap.code.question + '-' + question.id"
              class="boss-table-data pega-pre-wrap"
              :data-test="'question-text-' + i"
              v-text="question.name"
            />
          </tr>
          <tr v-if="isSecretPlan">
            <th>シークレットプランフラグ</th>
            <td
              :id="targetIdMap.code.isSecretPlan"
              class="boss-table-data"
              data-test="secret"
            >
              シークレット
            </td>
          </tr>
          <tr v-if="companyStaffText">
            <th>★ 企業ご担当者様</th>
            <td
              :id="targetIdMap.code.companyStaff"
              class="boss-table-data pega-pre-wrap"
              data-test="company-staff"
              v-text="companyStaffText"
            />
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import PreviewJobComments from '@/components/molecules/PreviewJobComments'
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import { parseHierarchicalObjects } from '@/lib/parse'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    PreviewJobComments
  },
  filters: {
    joinArray (val) {
      return val.join(' 、 ')
    }
  },
  mixins: [jobPreviewCommon],
  props: {
    codeSetting: {
      type: Object,
      required: true
    },
    displayCompanyName: {
      type: String,
      required: true
    },
    officialCompanyName: {
      type: String,
      required: true
    },
    companyNameKana: {
      type: String,
      required: true
    },
    isSecretPlan: {
      type: Boolean,
      default: false
    },
    isNotOutputGoogleForJobs: {
      type: Boolean,
      required: true
    },
    commentHighlights: {
      type: Array,
      default: () => []
    },
    isShowComment: {
      type: Boolean,
      required: true
    },
    isOnlyFullRemote: { // FIXME 未使用
      type: Boolean,
      default: false
    },
    isClientJob: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isFinishCreated: false
    }
  },
  computed: {
    ...mapGetters([
      'businessesMaster',
      'skillExpMaster'
    ]),
    buisinessTexts () {
      // 1件も指定されていない場合（企業を作成したばかりの時）は、１件目を空欄で表示する
      if (!this.codeSetting.businesses.length) return ['']

      const parseBusinessesMaster = parseHierarchicalObjects(this.businessesMaster)
      return this.codeSetting.businesses.map(i => {
        const business = parseBusinessesMaster.find(master => master.id === i)
        return business.path[0].name + ' ／ ' + business.path[1].name
      })
    },
    showOtherOfferJobNameList () {
      return this.codeSetting.otherOfferJobNameList?.length
    },
    showBulletPointsToOtherOfferJobName () {
      return this.codeSetting.otherOfferJobNameList && this.codeSetting.otherOfferJobNameList.length > 1
    },
    showExpSkills () {
      return this.codeSetting.expSkills && this.codeSetting.expSkills.length
    },
    showExpLicenses () {
      return this.codeSetting.expLicenses && this.codeSetting.expLicenses.length
    },
    companyStaffText () {
      return this.codeSetting.companyStaffs
        .map(m => m.name + ' 様（' + m.email + '）  ' + m.tel
        ).join('\n')
    },
    jobSkillString () {
      const skillObjectBase = _.groupBy(
        _.filter(parseHierarchicalObjects(this.skillExpMaster), master => {
          return this.codeSetting.expSkills.includes(master.id)
        }),
        o => o.path[1].name)
      const skillObj = {}
      for (const key in skillObjectBase) {
        if (skillObjectBase[key].find(m => m.path.length === 4)) {
          const nestSkillObject = _.groupBy(skillObjectBase[key], o => o.path[1].name + o.path[2].name)
          for (const key in nestSkillObject) {
            skillObj[key] = nestSkillObject[key]
          }
        } else {
          skillObj[key] = skillObjectBase[key]
        }
      }
      const skills = []
      for (const key in skillObj) {
        skills.push('■ ' + key + '\n ' + skillObj[key].map(m => m.name).join('、'))
      }
      return skills.join('\n\n')
    },
    jobLicenseString () {
      const licenseObj = _.groupBy(
        _.filter(parseHierarchicalObjects(this.skillExpMaster), master => {
          return this.codeSetting.expLicenses.includes(master.id)
        }),
        o => o.path[1].name)
      const licenses = []
      for (const key in licenseObj) {
        licenses.push('■ ' + key + '\n ' + licenseObj[key].map(m => m.name).join('、'))
      }
      return licenses.join('\n\n')
    },
    codeCommentHighlights () {
      return this.commentHighlights.filter(commentHighlight => commentHighlight.target.startsWith(this.targetIdMap.code.prefix))
    },
    usedAffiliatedSiteLabel: () => '※提携サイト掲載時にこちらの社名が使用されます。'
  },
  watch: {
    async isFinishCreated () {
      await this.$nextTick()
      this.isFinishCreated && this.codeCommentHighlights.forEach((commentHighlight) => {
        this.setHighlight(commentHighlight)
      })
    }
  },
  created () {
    Promise.all([
      this.storeMaster('businesses'),
      this.storeMaster('skillExp')
    ]).then(() => { this.isFinishCreated = true })
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    dispOtherOfferJobName (offerJobName) {
      return this.showBulletPointsToOtherOfferJobName ? `・ ${offerJobName}` : offerJobName
    }
  }
}
</script>
